import { render, staticRenderFns } from "./SliderBig.vue?vue&type=template&id=2dea144a"
import script from "./SliderBig.vue?vue&type=script&lang=js"
export * from "./SliderBig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports